<script>
import List from '@/components/ListDefault'

export default {
  name: "ListCISComplaints",

  components: {
    List,
  },

  data() {
    return {
      search: '',
      formview: 'FormCISComplaint',
      table: 'cis_complaint',
    }
  },


  computed: {
    headers() {
      return [
        { text: 'Datum', value: 'date' },
        { text: 'Firma', value: 'company' },
        { text: 'Name', value: 'name' },
        { text: 'Telefon', value: 'phone' },
        { text: 'Text', value: 'text' },
        { text: 'Task ID', value: 'cis_task_id' },
        { text: 'KIS-Benutzer', value: 'cis_user_email' },
        { text : 'Status' , value :'completed'},
        { text: '', value: 'edit' },
      ];
    },
  },
  created() {
  console.log('ListCISComplaints');
  console.log('Table:', this.table);
  
  },
 mounted() {
  console.log('ListCISComplaints headers:', this.headers);
 }
};
</script>

<template>
  <div>
    <List
    v-bind:headers="headers"
    v-bind:table="table"
    v-bind:default_limit="'1000'"
    v-bind:default_sort="'name'"
    v-bind:extension="''"
    v-bind:formview="formview" 
    v-bind:export_csv="false"
    v-bind:addbutton="true"

></List>
  </div>
</template>

<style scoped>
</style>
